import api from "./helper/client";
import { API_ROUTES } from "./helper/routes";

export const getAllUsers = async (tenantId: number) => {
    const response = await api.get(`${API_ROUTES.USER}/list/${tenantId}`);
    return response.data.data;
}

export const changePassword = async (
    userId: number,
    newPassword: string,
    currentPassword?: string
) => {
    const payload: Record<string, any> = {
        user_id: userId,
        new_password: newPassword,
        new_password_confirmation: newPassword,
    };
    if (currentPassword) {
        payload.current_password = currentPassword;
    }
    const response = await api.post(API_ROUTES.CHANGE_PASSWORD, payload);
    return response;
};